import React, { useEffect, useMemo, useState } from 'react';
import { CATEGORY_DESCRIPTION_MAX_LEN } from '../Actions/ProductListing.action';
import { translate } from '../Services/translation';

const ProductListHeaderText = (props) => {
  const [collapse, setCollapse] = useState<boolean | null>(null);

  const wordLength = useMemo(() => props.value.length, [props.value]);

  const resultSubstr = useMemo(
    () => props.value.substring(0, CATEGORY_DESCRIPTION_MAX_LEN),
    [props.value]
  );

  const collapsedText = useMemo(
    () =>
      props.value.length > 0
        ? resultSubstr.substring(
            0,
            Math.min(resultSubstr.length, resultSubstr.lastIndexOf(' '))
          ) + '...'
        : props.value,
    [props.value, resultSubstr]
  );

  useEffect(
    () => setCollapse(wordLength >= CATEGORY_DESCRIPTION_MAX_LEN),
    [wordLength]
  );

  return (
    resultSubstr.length > 0 && collapse !== null && (
      <>
        {!collapse && (
          <>
            <div
              className="text-lg mb-2 [&_p:not(:last-child)]:mb-1 leading-[1.5]"
              dangerouslySetInnerHTML={{
                __html: props.value,
              }}
            />
            {wordLength >= CATEGORY_DESCRIPTION_MAX_LEN && (
              <a
                className="text-md font-satoshi-bold underline cursor-pointer uppercase"
                onClick={() => setCollapse(true)}
              >
                {translate('productlist.showless')}
              </a>
            )}
          </>
        )}
        {collapse && (
          <>
            <div
              className="text-lg max-h-[8.1rem] break-words	overflow-hidden mb-2"
              dangerouslySetInnerHTML={{
                __html: collapsedText,
              }}
            />
            <a
              className="text-md font-satoshi-bold underline cursor-pointer uppercase"
              onClick={() => setCollapse(false)}
            >
              {translate('productlist.showmore')}
            </a>
          </>
        )}
      </>
    )
  );
};

export default ProductListHeaderText;
